import $ from 'jquery';

import { $Elements, Classes, Events } from './constants';
import { closeMenu, enableBodyScroll, openMenu, smoothScrollTo } from './helpers';

$Elements.document.on(Events.page.enter, () => {

	// ---------- Menu ----------

	$Elements.PageWrapper.on(Events.click, '.menu-toggle, a[href="#menu-wrapper"]', function(e) {
		e.preventDefault();

		if($Elements.body.hasClass(Classes.menuOpen)) {
			closeMenu();
		}
		else {
			openMenu();
		}
	});

	$(document).on(Events.click, function(e) {
		if($Elements.body.hasClass(Classes.menuOpen)) {

			if(
				!$(e.target).closest('#menu-wrapper').length &&
				!$(e.target).closest('.menu-toggle').length
			) {
				closeMenu();
			}
		}
	});

	$Elements.PageWrapper.on(Events.click, '#menu-wrapper', function(e) {
		e.stopPropagation();
	});

	$Elements.PageWrapper.on(Events.click, '.navbar-menu a, .menu-wrapper a', function(e) {

		const linkTarget = this.getAttribute('href');
		const sectionTarget = linkTarget.substring(linkTarget.lastIndexOf('#'), linkTarget.length);

		if(sectionTarget.substring(0, 1) === '#') {

			e.preventDefault();

			const section = $(sectionTarget);

			if(section.length) {

				window.history.replaceState(null, null, sectionTarget);

				$Elements.body.removeClass(Classes.menuOpen);
				enableBodyScroll()
				smoothScrollTo(section);
			}
			else if(sectionTarget !== '#') {
				window.location = linkTarget;
			}
		}
	});
});

$Elements.document.on(Events.page.loaded, () => {

	const linkTarget = window.location.href;
	const sectionTarget = linkTarget.substring(linkTarget.lastIndexOf('#'), linkTarget.length);

	if(sectionTarget.substring(0, 1) === '#') {

		const section = $(sectionTarget);

		if(section.length) {
			smoothScrollTo(section, 0);
		}
	}
});
